// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pageWrapper_wrapper__2ZYw7"};